import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';

export type ApiSource = 'nodejs' | 'php';

@Injectable({
  providedIn: 'root'
})
export class ApiSwitcherService {
  private static readonly STORAGE_KEY = 'cllaj_api_source';

  /** Original URLs from environment (immutable backup) */
  private readonly originalNodeUrl: string;
  private readonly originalPhpUrl: string;

  /** Emits when the API source changes */
  apiSourceChanged = new EventEmitter<ApiSource>();

  constructor() {
    this.originalNodeUrl = environment.apiUrl;
    this.originalPhpUrl = environment.phpApiUrl;

    // Apply saved preference (default: environment.defaultApiSource)
    const saved = this.getSavedSource();
    this.applySource(saved);
  }

  get currentSource(): ApiSource {
    return this.getSavedSource();
  }

  get activeApiUrl(): string {
    return environment.apiUrl;
  }

  get nodeApiUrl(): string {
    return this.originalNodeUrl;
  }

  get phpApiUrl(): string {
    return this.originalPhpUrl;
  }

  switchTo(source: ApiSource): void {
    this.applySource(source);
    localStorage.setItem(ApiSwitcherService.STORAGE_KEY, source);
    this.apiSourceChanged.emit(source);
    console.log(`[ApiSwitcher] Switched to ${source.toUpperCase()} API: ${environment.apiUrl}`);
  }

  toggle(): void {
    this.switchTo(this.currentSource === 'nodejs' ? 'php' : 'nodejs');
  }

  private getSavedSource(): ApiSource {
    // When comparison is disabled (prod/preprod), always use env default — ignore localStorage
    if (!(environment as any).enableApiComparison) {
      return (environment as any).defaultApiSource || 'nodejs';
    }
    const saved = localStorage.getItem(ApiSwitcherService.STORAGE_KEY);
    if (saved === 'nodejs' || saved === 'php') return saved;
    return (environment as any).defaultApiSource || 'nodejs';
  }

  private applySource(source: ApiSource): void {
    if (source === 'php' && this.originalPhpUrl) {
      (environment as any).apiUrl = this.originalPhpUrl;
      (environment as any).uploadedFilesUrl = this.originalPhpUrl + '/filebypath/';
    } else {
      (environment as any).apiUrl = this.originalNodeUrl;
      (environment as any).uploadedFilesUrl = this.originalNodeUrl + '/filebypath/';
    }
  }
}
